import { Box, styled } from '@mui/material';
import { motion } from 'framer-motion';

interface QuizStepNumberProps {
  /** 1-indexed step number shown inside the circle */
  step: number;
  /** When true renders the green checkmark instead of the step number */
  completed?: boolean;
}

export function QuizStepNumber({ step, completed = false }: QuizStepNumberProps) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3, delay: 0.05, ease: 'easeOut' }}
      style={{ display: 'flex', alignItems: 'center', gap: 12 }}
    >
      {completed ? (
        <StepCircle aria-hidden="true" sx={{ backgroundColor: 'success.main' }}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ color: '#ffffff' }}
          >
            <path
              d="M5 13L9 17L19 7"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </StepCircle>
      ) : (
        <StepCircle aria-hidden="true" sx={{ backgroundColor: 'primary.main' }}>
          <Box
            component="span"
            sx={{
              color: '#ffffff',
              fontWeight: 600,
              fontSize: '1.125rem',
              lineHeight: 1,
            }}
          >
            {step}
          </Box>
        </StepCircle>
      )}
    </motion.div>
  );
}

const StepCircle = styled(Box)(({ theme }) => ({
  width: 40,
  height: 40,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  [theme.breakpoints.up('sm')]: {
    width: 48,
    height: 48,
  },
}));
